import { useEffect } from 'react';

export const useScrollClose = (
  isVisible: boolean,
  isHovered: boolean,
  onClose?: () => void
) => {
  useEffect(() => {
    const handleScroll = () => {
      if (isHovered && onClose) {
        onClose();
      }
    };

    if (isVisible) {
      window.addEventListener('wheel', handleScroll);
    }

    return () => {
      window.removeEventListener('wheel', handleScroll);
    };
  }, [isVisible, isHovered, onClose]);
}; 